import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const clientsApi = createApi({
  reducerPath: 'clientsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL + '/clients',
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem('user');
      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllClients: builder.query({
      query: () => '',
    }),
    getClientById: builder.query({
      query: (idClient) => `/find/${idClient}`,
    }),
    searchClient: builder.query({
      query: (search) => `/search/${search}`,
    }),
    createClient: builder.mutation({
      query(body) {
        return {
          url: `/create`,
          method: 'POST',
          body,
        };
      },
    }),
    updateClient: builder.mutation({
      query(data) {
        const { id, body } = data;
        return {
          url: `/update/${id}`,
          method: 'POST',
          body,
        };
      },
    }),
    deleteClient: builder.mutation({
      query(id) {
        return {
          url: `/${id}`,
          method: 'DELETE',
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllClientsQuery,
  useSearchClientQuery,
  useCreateClientMutation,
  useUpdateClientMutation,
  useDeleteClientMutation,
} = clientsApi;
